
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-18891.084 -23885.699 12.363 12.398"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_158_1","data-name":"Symbol 158 – 1","transform":"translate(-19909.385 -25147)","opacity":".74"}},[_c('g',{attrs:{"id":"Group_8140","data-name":"Group 8140"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3392","d":"M18.9 12.407l7.259-7.3L23.052 2l-7.259 7.3L15.2 13z","data-name":"Path 3392","transform":"translate(1003.8 1260)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1636","d":"M0 0l2.889 2.889","data-name":"Line 1636","transform":"translate(1024.963 1264.148)"}})])])])
          )
        }
      }
    